
import  {
    faCaretUp,
} from "@awesome.me/kit-db56931b65/icons/sharp/regular";

const sharpRegular = {
    faCaretUp,
};

export {
    sharpRegular,
};
